/**
 * Shared utility class strings for the primitives.
 *
 * Every string here refers to CSS custom properties from `tokens.css`.
 * No hex code ever appears in component code.
 */

/**
 * Focus ring. `outline` rather than `ring` so it works on light and dark
 * surfaces without needing a matching ring-offset colour.
 *
 * Accent on `--surface-page` is 4.83:1, on `--ink-800` 3.49:1 — both clear the
 * 3:1 required for a non-text focus indicator.
 */
export const focusRing =
    'outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--accent)]';

/**
 * Focus ring for controls sitting directly on a dark header where the accent is
 * too close to the background — falls back to a white outline.
 */
export const focusRingOnDark =
    'outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--text-on-dark)]';

/** Disabled treatment. Applied by every interactive primitive. */
export const disabledStyles = 'disabled:cursor-not-allowed disabled:opacity-50';

/**
 * Font families, explicit. Primitives never inherit a family.
 * The `family-name:` hint is required: bare `font-[...]` is ambiguous with weight.
 */
export const fontBody = 'font-[family-name:var(--font-body)]';
export const fontDisplay = 'font-[family-name:var(--font-display)]';
export const fontMono = 'font-[family-name:var(--font-mono)]';

/** Card shell: white, 1px border, radius 10. No shadow inside the app. */
export const cardShell =
    'bg-[var(--surface-card)] border border-[var(--border-default)] rounded-[10px] text-[var(--text-primary)]';

/** The hatch used for every image placeholder in the design. */
export const placeholderHatch = 'bg-[image:var(--placeholder-hatch)]';

/** Horizontal scroll container for wide tables. Never clip, never squeeze. */
export const scrollX = 'overflow-x-auto overscroll-x-contain';
